import horaPlanets from '../data/horaPlanets.json';
import { tithiNature } from './tithiNature';
import { classifyMuhurta } from './muhurtaClassifier';

const LORD_PHRASES = {
  Sun: {
    auspicious: {
      en: 'The nakshatra lord Sun lends clarity of purpose to the answer.',
      ta: 'நட்சத்திர அதிபதி சூரியன் பதிலுக்கு தெளிவான நோக்கத்தை வழங்குகிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Sun asks that pride not cloud the path ahead.',
      ta: 'நட்சத்திர அதிபதி சூரியன் கர்வம் வழியை மறைக்காமல் இருக்க கேட்கிறார்.',
    },
  },
  Moon: {
    auspicious: {
      en: 'The nakshatra lord Moon softens the heart to receive the blessing.',
      ta: 'நட்சத்திர அதிபதி சந்திரன் ஆசீர்வாதத்தைப் பெற இதயத்தை மென்மையாக்குகிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Moon reminds the mind to remain steady under changing feelings.',
      ta: 'நட்சத்திர அதிபதி சந்திரன் மாறும் உணர்வுகளிடையே மனதை உறுதியாய் வைக்க நினைவூட்டுகிறார்.',
    },
  },
  Mars: {
    auspicious: {
      en: 'The nakshatra lord Mars lends courage to act on the answer.',
      ta: 'நட்சத்திர அதிபதி செவ்வாய் பதிலை செயல்படுத்தும் துணிவை வழங்குகிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Mars advises restraint before decisive action.',
      ta: 'நட்சத்திர அதிபதி செவ்வாய் தீர்க்க செயலுக்கு முன் கட்டுப்பாட்டை அறிவுறுத்துகிறார்.',
    },
  },
  Mercury: {
    auspicious: {
      en: 'The nakshatra lord Mercury favors clear thought and careful speech.',
      ta: 'நட்சத்திர அதிபதி புதன் தெளிவான சிந்தனையையும் கவனமான பேச்சையும் ஆதரிக்கிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Mercury warns that words chosen now carry weight.',
      ta: 'நட்சத்திர அதிபதி புதன் இப்போது தேர்ந்தெடுக்கும் வார்த்தைகள் பாரமாய் இருக்கும் என எச்சரிக்கிறார்.',
    },
  },
  Jupiter: {
    auspicious: {
      en: 'The nakshatra lord Jupiter blesses the question with wisdom and grace.',
      ta: 'நட்சத்திர அதிபதி குரு கேள்வியை ஞானத்தாலும் கருணையாலும் ஆசீர்வதிக்கிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Jupiter suggests consulting a trusted elder.',
      ta: 'நட்சத்திர அதிபதி குரு நம்பிக்கையான பெரியோரை அணுக அறிவுறுத்துகிறார்.',
    },
  },
  Venus: {
    auspicious: {
      en: 'The nakshatra lord Venus adds beauty and harmony to the unfolding.',
      ta: 'நட்சத்திர அதிபதி சுக்ரன் விரியும் நிகழ்வில் அழகையும் இணக்கத்தையும் சேர்க்கிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Venus invites kindness where disagreement tempts.',
      ta: 'நட்சத்திர அதிபதி சுக்ரன் முரண்பாடு தோன்றும் இடத்தில் கருணையை வரவேற்கிறார்.',
    },
  },
  Saturn: {
    auspicious: {
      en: 'The nakshatra lord Saturn honors patience and steady effort.',
      ta: 'நட்சத்திர அதிபதி சனி பொறுமையையும் நிலையான முயற்சியையும் மதிக்கிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Saturn signals that results take time; persevere.',
      ta: 'நட்சத்திர அதிபதி சனி பலன் காலம் எடுக்கும் என குறிக்கிறார்; தொடருங்கள்.',
    },
  },
  Rahu: {
    auspicious: {
      en: 'The nakshatra lord Rahu opens unconventional paths to the answer.',
      ta: 'நட்சத்திர அதிபதி ராகு பதிலுக்கு வழக்கத்திற்கு மாறான பாதைகளைத் திறக்கிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Rahu cautions against illusion; seek clarity.',
      ta: 'நட்சத்திர அதிபதி ராகு மாயையை எச்சரிக்கிறார்; தெளிவு தேடுங்கள்.',
    },
  },
  Ketu: {
    auspicious: {
      en: 'The nakshatra lord Ketu guides toward inner knowing and detachment.',
      ta: 'நட்சத்திர அதிபதி கேது உள்ளுணர்வு மற்றும் துறவு நோக்கி வழிநடத்துகிறார்.',
    },
    difficult: {
      en: 'The nakshatra lord Ketu asks what can be released for the answer to land.',
      ta: 'நட்சத்திர அதிபதி கேது பதில் இறங்க எது விடப்பட வேண்டும் என கேட்கிறார்.',
    },
  },
};

const TITHI_NATURE_PHRASES = {
  Nanda: {
    en: 'The tithi Nanda favors joyful beginnings.',
    ta: 'நந்த திதி மகிழ்ச்சியான துவக்கங்களை ஆதரிக்கிறது.',
  },
  Bhadra: {
    en: 'The tithi Bhadra supports steady growth and expansion.',
    ta: 'பத்ரா திதி நிலையான வளர்ச்சியை ஆதரிக்கிறது.',
  },
  Jaya: {
    en: 'The tithi Jaya points to victory earned through effort.',
    ta: 'ஜெயா திதி முயற்சியால் கிடைக்கும் வெற்றியைக் குறிக்கிறது.',
  },
  Rikta: {
    en: 'The tithi Rikta is a time to release rather than accumulate.',
    ta: 'ரிக்தா திதி சேர்ப்பதை விட விடுதல் பொருந்தும் நேரம்.',
  },
  Purna: {
    en: 'The tithi Purna carries the quality of completion and fulfillment.',
    ta: 'பூர்ண திதி நிறைவையும் பூர்த்தியையும் கொண்டுவருகிறது.',
  },
  Neutral: {
    en: 'The tithi contributes a neutral background to the moment.',
    ta: 'திதி இந்த தருணத்திற்கு நடுநிலையான பின்னணியை அளிக்கிறது.',
  },
};

const CLOSING_GUIDANCE = {
  green: {
    en: 'This is a favorable moment for your inquiry. Receive the answer with quiet confidence and act with devotion.',
    ta: 'இது உங்கள் வினாவுக்கு சாதகமான நேரம். அமைதியான நம்பிக்கையுடன் பதிலை ஏற்று, பக்தியுடன் செயல்படுங்கள்.',
  },
  yellow: {
    en: 'The cosmic moment is mixed. Reflect on the verse with both hope and discernment.',
    ta: 'பிரபஞ்ச நேரம் கலப்பாக உள்ளது. நம்பிக்கையுடனும், பகுத்தறிவுடனும் சுலோகத்தை சிந்தியுங்கள்.',
  },
  red: {
    en: 'The current moment carries some weight of caution. Consider re-asking after this window ends.',
    ta: 'இந்த தருணம் சற்றே கவனத்தை வேண்டுகிறது. இந்த காலம் முடிந்தபின் மீண்டும் கேட்கலாம்.',
  },
};

const OPENING_TEMPLATE = {
  en: ({ nakshatra, lord, paksha, tithi, hora }) =>
    `Your question was asked during ${nakshatra} nakshatra (ruled by ${lord}), in ${paksha} ${tithi}, during the hora of ${hora}.`,
  ta: ({ nakshatra, lord, paksha, tithi, hora }) =>
    `உங்கள் கேள்வி ${nakshatra} நட்சத்திரத்தில் (அதிபதி ${lord}), ${paksha} ${tithi} திதியில், ${hora} ஹோரையில் கேட்கப்பட்டது.`,
};

const PAKSHA_LABEL = {
  en: { shukla: 'Shukla', krishna: 'Krishna' },
  ta: { shukla: 'சுக்ல', krishna: 'கிருஷ்ண' },
};

function pickLang(lang) {
  return lang === 'ta' ? 'ta' : 'en';
}

function toneCol(verseTone) {
  return verseTone === 'difficult' ? 'difficult' : 'auspicious';
}

export function lordPhrase(lordName, verseTone, lang) {
  const entry = LORD_PHRASES[lordName];
  if (!entry) return '';
  return entry[toneCol(verseTone)][pickLang(lang)];
}

export function horaPhrase(planetEn, verseTone, lang) {
  const entry = horaPlanets.find((h) => h.planet_en === planetEn);
  if (!entry) return '';
  const l = pickLang(lang);
  const key = toneCol(verseTone) === 'auspicious' ? 'auspicious_phrase' : 'difficult_phrase';
  return entry[`${key}_${l}`] || '';
}

export function tithiPhrase(tithiNum, lang) {
  const nature = tithiNature(tithiNum);
  const entry = TITHI_NATURE_PHRASES[nature] || TITHI_NATURE_PHRASES.Neutral;
  return entry[pickLang(lang)];
}

export function closingGuidance(muhurtaQuality, lang) {
  const entry = CLOSING_GUIDANCE[muhurtaQuality] || CLOSING_GUIDANCE.yellow;
  return entry[pickLang(lang)];
}

export function composeInterpretation(snapshot, verseTone, lang) {
  if (!snapshot) return { opening: '', middle: '', closing: '' };
  const l = pickLang(lang);

  const nakName = l === 'ta' ? snapshot.nakshatra.name_ta : snapshot.nakshatra.name_en;
  const lordName = l === 'ta' ? snapshot.nakshatra.lord_ta : snapshot.nakshatra.lord_en;
  const pakshaKey = snapshot.tithi && snapshot.tithi.paksha === 'krishna' ? 'krishna' : 'shukla';
  const paksha = PAKSHA_LABEL[l][pakshaKey];
  const tithiName = l === 'ta' ? snapshot.tithi.name_ta : snapshot.tithi.name_en;
  const horaName = l === 'ta' ? snapshot.hora.planet_ta : snapshot.hora.planet_en;

  const opening = OPENING_TEMPLATE[l]({
    nakshatra: nakName,
    lord: lordName,
    paksha,
    tithi: tithiName,
    hora: horaName,
  });

  const middle = [
    lordPhrase(snapshot.nakshatra.lord_en, verseTone, l),
    horaPhrase(snapshot.hora.planet_en, verseTone, l),
    tithiPhrase(snapshot.tithi.number, l),
  ]
    .filter(Boolean)
    .join(' ');

  const quality = classifyMuhurta(snapshot);
  const closing = closingGuidance(quality, l);

  return { opening, middle, closing };
}
